// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import { store } from './store'
import VueAxios from 'vue-axios'
import { securedAxiosInstance, plainAxiosInstance } from './backend/axios'
import Toasted from 'vue-toasted'
import FloatingVue from 'floating-vue'
import 'floating-vue/dist/style.css'
import { registerToasted } from '@/lib/plugins/toasted'
import VueScrollTo from 'vue-scrollto'
import VuejsDialog from 'vuejs-dialog'
import 'vuejs-dialog/dist/vuejs-dialog.min.css'
import VueProgressBar from 'vue-progressbar'
import 'what-input'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/ja'
import sanitizeHTML from 'sanitize-html'
import { version } from '../package.json'
import VueGtag from 'vue-gtag'
import dayjs from 'dayjs'
import 'dayjs/locale/ja'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import isBetween from 'dayjs/plugin/isBetween'
import isoWeek from 'dayjs/plugin/isoWeek'
import customParseFormat from 'dayjs/plugin/customParseFormat'

dayjs.locale('ja')
dayjs.extend(isSameOrAfter)
dayjs.extend(isSameOrBefore)
dayjs.extend(isBetween)
dayjs.extend(isoWeek)
dayjs.extend(customParseFormat)

const isCheckNewVersion = process.env.NODE_ENV !== 'development'
const googleTagId = process.env.GOOGLE_TAG_ID

Vue.use(VueProgressBar, {
  color: '#419cd9',
  failedColor: 'red',
  thickness: '2px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 600
  },
  autoFinish: false
})

Vue.use(Toasted, {
  iconPack: 'custom-class',
  theme: 'toasted-primary',
  type: 'success',
  className: 'pega-width-20-rem pega-toasted-vertical pega-toasted-success pega-pre-wrap',
  position: 'bottom-right',
  duration: 5000
})
registerToasted(Vue.toasted)

Vue.config.productionTip = false
Vue.use(VueAxios, {
  secured: securedAxiosInstance,
  plain: plainAxiosInstance
})
Vue.axios.secured.interceptors.request.use(request => {
  Vue.prototype.$Progress.start()
  return request
})
Vue.axios.secured.interceptors.response.use(response => {
  Vue.prototype.$Progress.finish()
  return response
},
error => {
  Vue.prototype.$Progress.fail()
  return Promise.reject(error)
})

Vue.use(FloatingVue, {
  // https://floating-vue.starpad.dev/guide/config
  // Element used to compute position and size boundaries
  boundary: 'window',
  strategy: 'fixed',
  // Themes
  themes: {
    tooltip: {
      // Default events that trigger the tooltip
      triggers: ['hover', 'click'],
      // Delay (ms)
      delay: {
        show: 500
      }
    }
  }
})
Vue.use(VueScrollTo, {
  easing: 'ease-in-out',
  duration: '1200'
})
Vue.use(VuejsDialog, {
  html: true,
  reverse: true,
  okText: 'はい',
  cancelText: 'いいえ',
  animation: 'fade'
})

// use v-scroll
Vue.directive('scroll', {
  inserted (el, binding) {
    const f = evt => {
      if (binding.value(evt, el)) {
        window.removeEventListener('scroll', f)
      }
    }
    window.addEventListener('scroll', f)
  }
})

Vue.prototype.$sanitize = sanitizeHTML

// 最新バージョンチェック処理
router.beforeEach((to, from, next) => {
  const noReloadPath = ['scoutCreate']
  if (isCheckNewVersion && !noReloadPath.includes(to.name)) {
    plainAxiosInstance.get(`/static/version_${version}.txt`).catch((error) => {
      // ファイルがない場合とアクセスできない場合にリロード
      [404, 403].includes(error.response.status) && window.location.reload()
    })
  }
  next()
})

!!googleTagId && Vue.use(VueGtag, {
  config: { id: googleTagId }
}, router)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  securedAxiosInstance,
  plainAxiosInstance,
  components: { App },
  template: '<App/>'
})
